// TODO: Get this from the environment
const API_BASE = process.env.REACT_APP_API_URL || 'https://newa-metadata.nysipm-admin.workers.dev';

let apiKey;

export const setAuthTokenForQueries = (key) => {
  apiKey = key;
}

export const fetchWithToken = async (url, options = {}) => {
  if (!apiKey) {
    throw new Error('No API key set for user');
  }

  const headers = {
    ...options.headers,
    'x-api-key': apiKey
  };

  const response = await fetch(url, {
    ...options,
    headers
  });

  return response.json();
}

// Mimics the relevant surface of the Fauna DB client to use the new api with minimal code changes in this app
export const client = {
  query: async (query) => {
    try {
      const result = await fetchWithToken(`${API_BASE}/${query.url}`, query.options);

      // If result doesn't match expected shape, transform it
      if (!result.data?.data) {
        return {
          data: {
            data: Array.isArray(result) ? result : [result]
          }
        };
      }
      return result;
    } catch (error) {
      console.error('API query error:', error);
      throw error;
    }
  }
}